// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2HRRi","unreadBadge":"styles_unreadBadge__2Qcle","modalContent":"styles_modalContent__2xCaz","modal":"styles_modal__1Q--Y"};